import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { OrderStatus, Order } from '../../../models/new/order';
import { Dialog } from '@angular/cdk/dialog';
import { CreateOrderModalComponent } from '../create-order-modal/create-order-modal.component';
import { AddToOrderChooseModalComponent } from '../add-to-order-choose-modal/add-to-order-choose-modal.component';
import { SelectedStylesModalComponent } from '../selected-styles-modal/selected-styles-modal.component';
import { Warehouse } from 'src/app/shared/types/warehouse.model';
import { FilterListComponent } from 'src/app/shared/components/filter-list/filter-list.component';
import { Selectable } from 'src/app/shared/types/selectable.type';
import { WarehouseFilterService } from 'src/app/services/filters/warehouse-filter.service';
import { Color, Size, Style } from '../../../models/new/style';
import _ from 'lodash';
import { ManageColorsSizesModalComponent } from '../../company-order-detail/company-order-detail-shots/add-product-modal/manage-colors-sizes-modal/manage-colors-sizes-modal.component';

@Component({
	selector: 'bt-add-to-order-modal',
	standalone: false,
	templateUrl: './add-to-order-modal.component.html',
	styleUrl: './add-to-order-modal.component.scss'
})
export class AddToOrderModalComponent {
	readonly dialogRef = inject(MatDialogRef<AddToOrderModalComponent>);
	readonly data = inject(MAT_DIALOG_DATA);
	styles: Style[] = [];

	constructor(private dialog: MatDialog) {
		//in style.warehouseArticles filtra per warehouse.id == data.warehouse.id
		this.styles = this.data.styles.map((s: Style) => {
			const style = new Style(s);
			style.warehouseArticles = style.warehouseArticles?.filter((wa) => wa.warehouse && wa.warehouse.id == this.data.warehouse.id);
			return style;
		});

		//per ogni style, assegna l'array colors con la prima size disponibile , sempre dall'array di warehouseArticles
		this.styles.forEach((s: Style) => {
			const colors: Color[] = [];

			s.warehouseArticles?.forEach((wa) => {
				if (wa.color && !colors.some((c) => c.id == wa.color?.id)) {
					const color = new Color({ id: wa.color.id, code: wa.color.code, name: wa.color.name });
					const size = wa.size ? new Size({ id: wa.size.id, name: wa.size.name }) : undefined;
					color.size = size;
					colors.push(color);
				}
			});

			s.colors = colors;
		});
	}

	openManageColorsSizesModal(style: Style): void {
		this.dialog
			.open(ManageColorsSizesModalComponent, {
				data: { style, singleColorSelection: false }
			})
			.afterClosed()
			.subscribe({
				next: (res: { color: Selectable<Color>; sizesAndQuantity: Selectable<{ size: Size; availableQty: number }>[] }[]) => {
					if (res) {
						style.colors = res
							.filter((c) => c.color.selected)
							.map((c) => {
								const color = new Color({ id: c.color.id, code: c.color.code, name: c.color.name });
								const size = c.sizesAndQuantity.filter((s) => s.selected).map((s) => new Size({ id: s.size.id, name: s.size.name }));

								color.size = size && size.length > 0 ? size[0] : undefined;
								return color;
							});
					}
				}
			});
	}

	openCreateNewOrderModal() {
		this.close();
		this.dialog.open(CreateOrderModalComponent, {
			data: {
				styles: this.styles,
				warehouse: this.data.warehouse
			}
		});
	}

	openAddToOrderModal() {
		this.close();
		this.dialog.open(AddToOrderChooseModalComponent, {
			data: {
				styles: this.styles,
				warehouse: this.data.warehouse
			}
		});
	}

	close() {
		this.dialogRef.close(null);
	}
}
